import { render, staticRenderFns } from "./Banned.vue?vue&type=template&id=663e022d&scoped=true&"
import script from "./Banned.vue?vue&type=script&lang=js&"
export * from "./Banned.vue?vue&type=script&lang=js&"
import style0 from "./Banned.vue?vue&type=style&index=0&id=663e022d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e022d",
  null
  
)

export default component.exports